import Image from "next/legacy/image";
import { Button } from 'ui';
import twMerge from 'utils/twMerge';

export default function BlogCTA({ className, ...attrs }) {
  return (
    <div
      className={twMerge('text-center bg-beige py-5 rounded-[10px]', className)}
      {...attrs}
    >
      <h4 className="font-serif text-[16px] leading-[27px] px-5 font-bold">
        Don’t know your personality type?
      </h4>
      <Image
        src="/images/blog-cta-image.svg"
        layout="responsive"
        width={255}
        height={152}
        alt=""
        unoptimized={true}
        objectFit="contain"
      />
      <Button
        href="/free-personality-test"
        as="a"
        className="px-5 !shadow-brown active:!shadow-green-inset mt-[2px]"
      >
        Take the test now
      </Button>
    </div>
  );
}
